module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Luzern_matt-243125c8f5d5b70ac7928b7c94d4ce52.svg";